import React from 'react'
import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import tutorialIcon from "../assets/icons/tutorial.svg";
import { Trans } from "react-i18next";

const UserGuide = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2026-03-05";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        return "";
    }
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          max-w-3xl
        "
            >
                <div className="
  relative flex items-center justify-between gap-3
  mobile:flex-col
  mobile:items-stretch
  desktop:flex-row-reverse
  tabletpro:flex-row-reverse
  tabletair:flex-row-reverse
  tabletmini:flex-row-reverse
  mini_mobile:flex-col mini_mobile:items-stretch
">
                    {/* Copy button */}
                    <div className="mobile:flex mobile:justify-end mobile:order-1 mini_mobile:flex mini_mobile:justify-end">
                        <CopyButton text={buildCopyText(t)} />
                    </div>

                    {/* Icon + text */}
                    <div className="flex items-center gap-1 mobile:order-2">
                        <img
                            src={tutorialIcon}
                            alt="tutorial"
                            className="w-9 h-16 mobile:w-9 mobile:h-9"
                        />
                        <p className="text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[28px] mobile:text-[28px] mini_mobile:text-[24px] font-semibold">
                            {t("sidebar.usage.title")}
                        </p>
                    </div>
                </div>


                <div className="mt-2 relative">
                    <section className='flex flex-col gap-4 mt-1'>
                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="InstallationGuide.description"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="InstallationGuide.description1"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="InstallationGuide.description2"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>
                    </section>

                    <section className='flex gap-4 mt-4 flex-col desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.install.itemGuideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS")}
                            to="/guide-to-adding-and-trusting-digital-certificates-from-cas-on-macos"
                        />
                        <NextSectionCard
                            label={t("sidebar.usage.login")}
                            to="/login-gopaperlessagent"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default UserGuide